import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createSlots as _createSlots, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "hr-page member-list-page" }
const _hoisted_2 = { class: "console-page-head" }
const _hoisted_3 = { class: "console-head-side" }
const _hoisted_4 = { class: "console-count" }
const _hoisted_5 = {
  key: 0,
  class: "member-service-tabs",
  role: "tablist"
}
const _hoisted_6 = ["aria-selected"]
const _hoisted_7 = { class: "tab-count" }
const _hoisted_8 = ["aria-selected"]
const _hoisted_9 = { class: "tab-count" }
const _hoisted_10 = { class: "hr-body" }
const _hoisted_11 = { class: "hr-main-layout" }
const _hoisted_12 = { class: "content-card" }
const _hoisted_13 = { class: "search-area" }
const _hoisted_14 = { class: "row-num" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "name-text" }
const _hoisted_17 = { class: "name-label" }
const _hoisted_18 = {
  key: 0,
  class: "source-chip source-chip--mall"
}
const _hoisted_19 = { class: "code-text" }
const _hoisted_20 = { class: "biz-chips" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["title"]
const _hoisted_23 = {
  key: 0,
  class: "assignee-more"
}
const _hoisted_24 = {
  key: 1,
  class: "no-manager"
}
const _hoisted_25 = ["title"]
const _hoisted_26 = {
  key: 0,
  class: "assignee-more"
}
const _hoisted_27 = {
  key: 1,
  class: "no-manager"
}
const _hoisted_28 = { class: "joined-date" }
const _hoisted_29 = ["title"]
const _hoisted_30 = { class: "activity-label" }
const _hoisted_31 = {
  key: 0,
  class: "activity-time"
}
const _hoisted_32 = { class: "action-btns" }
const _hoisted_33 = { class: "empty-message" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "edit-grid" }
const _hoisted_36 = { class: "edit-section" }
const _hoisted_37 = { class: "edit-row" }
const _hoisted_38 = { class: "edit-row" }
const _hoisted_39 = { class: "edit-row edit-row--assignee" }
const _hoisted_40 = { class: "assignee-multi" }
const _hoisted_41 = ["checked", "disabled", "onChange"]
const _hoisted_42 = { class: "edit-row" }
const _hoisted_43 = { class: "edit-row" }
const _hoisted_44 = { class: "input-group" }
const _hoisted_45 = { class: "edit-row" }
const _hoisted_46 = {
  key: 0,
  class: "status-buttons"
}
const _hoisted_47 = {
  key: 1,
  class: "assignee-readonly"
}
const _hoisted_48 = { class: "edit-section" }
const _hoisted_49 = { class: "edit-row" }
const _hoisted_50 = { class: "edit-row" }
const _hoisted_51 = { class: "edit-row" }
const _hoisted_52 = { class: "edit-section full" }
const _hoisted_53 = { class: "edit-row edit-row--assignee" }
const _hoisted_54 = { class: "assignee-multi" }
const _hoisted_55 = ["value", "checked", "onChange"]
const _hoisted_56 = {
  key: 0,
  class: "no-manager"
}
const _hoisted_57 = {
  key: 1,
  class: "no-manager"
}
const _hoisted_58 = { class: "edit-row edit-row--assignee" }
const _hoisted_59 = { class: "assignee-multi" }
const _hoisted_60 = ["value", "checked", "onChange"]
const _hoisted_61 = { class: "edit-row" }
const _hoisted_62 = { class: "assignee-readonly" }
const _hoisted_63 = { class: "edit-row" }
const _hoisted_64 = { class: "assignee-readonly" }
const _hoisted_65 = { class: "edit-row" }
const _hoisted_66 = { class: "edit-row" }

import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { memberApi, userApi } from '@/services/api';
import TablePagination from '@/components/common/TablePagination.vue';
import DeleteConfirmDialog from '@/components/common/DeleteConfirmDialog.vue';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';

const ASSIGNEE_VISIBLE_MAX = 2;


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberList',
  setup(__props) {

const store = useStore();

const currentUser = computed(() => store.getters.currentUser);
const userOrgCode = computed(() => store.getters.orgCode);
const userRoleLevel = computed(() => store.getters.roleLevel);
const actualRoleLevel = computed(() => store.getters.actualRoleLevel ?? store.getters.roleLevel);
/** ADMIN+(90+) — 담당 배정·기관 삭제·활성/비활성. 임금·회계 담당(배정)은 불가 */
const isAdmin = computed(() => Number(actualRoleLevel.value) >= 90);
const canDeleteMember = computed(() => isAdmin.value);
/** 관리자(80+)만 임금·회계 이용 / 서비스 미이용 탭 */
const canSeeServiceTabs = computed(() => {
  const level = store.getters.isImpersonating
    ? Number(userRoleLevel.value)
    : Number(actualRoleLevel.value);
  return level >= 80;
});
// 상태
const loading = ref(false);
const memberList = ref<any[]>([]);
const totalCount = ref(0);
const currentPage = ref(1);
const itemsPerPage = ref(20);
const searchText = ref('');
const selectedBizGubun = ref('');
const selectedStatus = ref<number | string>(1); // 기본값: 활성
const serviceTab = ref<'service' | 'none'>('service');
const tabCounts = ref({ service: 0, none: 0 });
const bizGubunList = ref<any[]>([]);
const bizGubunColorMap = ref<Record<string, string>>({});

const emptyListMessage = computed(() => {
  if (!canSeeServiceTabs.value) return '등록된 기관이 없습니다.';
  return serviceTab.value === 'service'
    ? '임금·회계 서비스를 이용 중인 기관이 없습니다.'
    : '서비스를 이용하지 않는 기관이 없습니다.';
});

// 사업구분 옵션 (전체 포함)
const bizGubunOptions = computed(() => {
  const options = [{ bg_name: '전체', bg_value: '', bg_color: '' }];
  return options.concat(bizGubunList.value.map(item => ({
    bg_name: item.bg_name,
    bg_value: item.bg_name,
    bg_color: item.bg_color,
    bg_exclusive_group: item.bg_exclusive_group
  })));
});

// 적용된 필터 개수
const filterCount = computed(() => {
  let count = 0;
  if (selectedBizGubun.value) count++;
  if (selectedStatus.value !== '') count++;
  if (searchText.value) count++;
  return count;
});

// 필터 적용 여부
const hasActiveFilters = computed(() => filterCount.value > 0);
const detailDialog = ref(false);
const selectedMember = ref<any>(null);

// 상세/수정 다이얼로그
const detailLoading = ref(false);
const editLoading = ref(false);
const editFormRef = ref<any>(null);
const editForm = ref<any>({});


// 담당자 목록 (상세 다이얼로그에서 사용)
const managerLoading = ref(false);
const managerList = ref<any[]>([]);
const wageAssigneeIds = ref<number[]>([]);
const accountAssigneeIds = ref<number[]>([]);

const toggleAssignee = (kind: 'wage' | 'account', uIdx: number, checked: boolean) => {
  const target = kind === 'wage' ? wageAssigneeIds : accountAssigneeIds;
  if (checked) {
    if (!target.value.includes(uIdx)) target.value = [...target.value, uIdx];
  } else {
    target.value = target.value.filter((id) => id !== uIdx);
  }
};

const onAssigneeCheck = (kind: 'wage' | 'account', uIdx: number, e: Event) => {
  const el = e.target as HTMLInputElement;
  toggleAssignee(kind, uIdx, !!el?.checked);
};

const syncAssigneeIdsFromForm = () => {
  wageAssigneeIds.value = (editForm.value.wage_assignees || []).map((a: any) => Number(a.u_idx));
  accountAssigneeIds.value = (editForm.value.account_assignees || []).map((a: any) => Number(a.u_idx));
};

// 멤버 삭제
const deleteDialog = ref(false);
const deleteTarget = ref<any>(null);
const deleteLoading = ref(false);

const statusOptions = [
  { text: '전체', value: '' },
  { text: '활성', value: 1 },
  { text: '비활성', value: 0 }
];

const headers = [
  { title: 'No', key: 'index', sortable: false, align: 'center' as const },
  { title: '시설명', key: 'm_name', sortable: true },
  { title: '사업구분', key: 'm_biz_gubun', sortable: true },
  { title: '임금담당', key: 'wage_manager', sortable: false },
  { title: '회계담당', key: 'account_manager', sortable: false },
  { title: '대표자', key: 'm_boss_name', sortable: true },
  { title: '가입일', key: 'm_wdate', sortable: true },
  { title: '최근 행동', key: 'last_activity', sortable: false },
  { title: '상태', key: 'm_status', sortable: true, align: 'center' as const },
  { title: '', key: 'actions', sortable: false }
];

const formatJoinedDate = (dateStr: string | null | undefined): string => {
  if (!dateStr) return '-';
  const s = String(dateStr);
  return s.length >= 10 ? s.slice(0, 10) : s;
};

const formatActivityTime = (dateStr: string | null | undefined): string => {
  if (!dateStr) return '';
  const date = new Date(String(dateStr).replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return String(dateStr).slice(0, 16);
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hm = `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
  if (days === 0) return `오늘 ${hm}`;
  if (days === 1) return '어제';
  if (days < 7) return `${days}일 전`;
  return String(dateStr).slice(0, 10);
};

const formatActivityFull = (dateStr: string | null | undefined): string => {
  if (!dateStr) return '';
  const s = String(dateStr);
  return s.length >= 16 ? s.slice(0, 16) : s;
};

/** 표: 담당자 최대 2명 표시, 나머지는 +N (호버로 전체) */
const assigneeNames = (list: any[] | undefined): string[] =>
  (list || []).map((a) => String(a?.u_name || '').trim()).filter(Boolean);

const visibleAssigneeNames = (list: any[] | undefined): string[] =>
  assigneeNames(list).slice(0, ASSIGNEE_VISIBLE_MAX);

const hiddenAssigneeCount = (list: any[] | undefined): number =>
  Math.max(0, assigneeNames(list).length - ASSIGNEE_VISIBLE_MAX);

const formatAssigneeTitle = (list: any[] | undefined): string =>
  assigneeNames(list).join(', ');

const totalPages = computed(() => Math.ceil(totalCount.value / itemsPerPage.value));

// 멤버 목록 조회
const fetchMemberList = async () => {
  loading.value = true;
  try {
    // 기본 파라미터 (검색/필터/페이지네이션)
    const params: Record<string, any> = {
      search: searchText.value || undefined,
      bizGubun: selectedBizGubun.value || undefined,
      status: selectedStatus.value !== '' ? selectedStatus.value : undefined,
      page: currentPage.value,
      limit: itemsPerPage.value,
      ...(canSeeServiceTabs.value ? { serviceScope: serviceTab.value } : {})
    };
    
    // 대리 로그인 중일 때만 orgCode/roleLevel 전달 (백엔드가 JWT 관리자 검증 후 사용)
    // 일반 로그인 시에는 백엔드가 JWT에서 직접 orgCode/roleLevel을 사용
    if (store.getters.isImpersonating) {
      params.roleLevel = userRoleLevel.value;
      params.userIdx = currentUser.value?.idx;
    }
    
    const response = await memberApi.getList(params);

    if (response.data.success) {
      memberList.value = response.data.data;
      totalCount.value = response.data.pagination.total;
      if (response.data.tabCounts) {
        tabCounts.value = {
          service: Number(response.data.tabCounts.service) || 0,
          none: Number(response.data.tabCounts.none) || 0
        };
      }
    }
  } catch (error: any) {
    // 로그아웃·세션 만료(401) 시에는 안내하지 않음
    if (error?.response?.status === 401) return;
    console.error('멤버 목록 조회 오류:', error);
    store.dispatch('showError', '멤버 목록을 불러오는데 실패했습니다.');
  } finally {
    loading.value = false;
  }
};

// 사업구분 목록 조회 (색상 포함)
const fetchBizGubunList = async () => {
  try {
    const response = await memberApi.getBizGubunList();
    if (response.data.success) {
      bizGubunList.value = response.data.data;
      // 색상 맵 생성
      const colorMap: Record<string, string> = {};
      response.data.data.forEach((item: any) => {
        colorMap[item.bg_name] = item.bg_color;
      });
      bizGubunColorMap.value = colorMap;
    }
  } catch (error) {
    console.error('사업구분 목록 조회 오류:', error);
  }
};

const clearOrgFilter = () => {
  currentPage.value = 1;
  fetchMemberList();
};

const clearBizGubunFilter = () => {
  selectedBizGubun.value = '';
  currentPage.value = 1;
  fetchMemberList();
};

const clearStatusFilter = () => {
  selectedStatus.value = '';
  currentPage.value = 1;
  fetchMemberList();
};

const clearSearchFilter = () => {
  searchText.value = '';
  currentPage.value = 1;
  fetchMemberList();
};

const clearAllFilters = () => {
  selectedBizGubun.value = '';
  selectedStatus.value = '';
  searchText.value = '';
  currentPage.value = 1;
  fetchMemberList();
};

const onClearSearch = () => {
  searchText.value = '';
  fetchMemberList();
};

const setServiceTab = (tab: 'service' | 'none') => {
  if (serviceTab.value === tab) return;
  serviceTab.value = tab;
  currentPage.value = 1;
  fetchMemberList();
};

const onPageChange = () => fetchMemberList();
const onItemsPerPageChange = () => {
  currentPage.value = 1;
  fetchMemberList();
};

// 시설 상세 팝업 열기 (새 창 - 좌측상단, 화면 높이 전체)
const openMemberPopup = (member: any) => {
  const url = `/member/detail/${member.m_code}`;
  const width = 2000;
  const height = window.screen.height;
  const left = 0;
  const top = 0;
  window.open(url, 'memberDetailPopup', `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`);
};

// 수정 다이얼로그 열기 (바로 편집 화면)
const openEditDialog = async (member: any) => {
  detailDialog.value = true;
  detailLoading.value = true;
  editForm.value = { m_name: member.m_name, m_status: member.m_status };
  try {
    const params = store.getters.isImpersonating
      ? { roleLevel: userRoleLevel.value, userIdx: currentUser.value?.idx }
      : {};
    const response = await memberApi.getById(member.m_idx, params);
    if (response.data.success) {
      selectedMember.value = response.data.data;
      editForm.value = { ...response.data.data };
      syncAssigneeIdsFromForm();
      // 담당자 체크박스 목록은 관리자만 로드
      if (isAdmin.value) {
        loadManagerList();
      } else {
        managerList.value = [];
      }
    }
  } catch (error: any) {
    detailDialog.value = false;
    if (error?.response?.status === 401) return;
    if (error.response?.status === 403) {
      store.dispatch('showError', '접근 권한이 없습니다.');
    } else {
      store.dispatch('showError', '멤버 정보를 불러오는데 실패했습니다.');
    }
  } finally {
    detailLoading.value = false;
  }
};

const closeEditDialog = () => {
  if (editLoading.value) return;
  detailDialog.value = false;
  selectedMember.value = null;
  editForm.value = {};
};

// 담당자 후보 목록 로드 (관리자 전체)
const loadManagerList = async () => {
  managerLoading.value = true;
  try {
    const response = await userApi.getManagers({
      orgCode: isAdmin.value ? undefined : userOrgCode.value,
      roleLevel: isAdmin.value ? 100 : userRoleLevel.value
    });
    if (response.data.success) {
      managerList.value = response.data.data;
    }
  } catch (error) {
    console.error('담당자 목록 조회 오류:', error);
  } finally {
    managerLoading.value = false;
  }
};

// 수정 저장 → 목록 갱신 후 창 닫기
const saveEdit = async () => {
  if (!editForm.value?.m_name?.trim()) {
    store.dispatch('showError', '시설명을 입력해주세요.');
    return;
  }
  editLoading.value = true;
  try {
    const updateData: Record<string, any> = {
      m_name: editForm.value.m_name,
      m_biz_gubun: editForm.value.m_biz_gubun,
      m_biz_num: editForm.value.m_biz_num,
      m_boss_name: editForm.value.m_boss_name,
      m_boss_phone: editForm.value.m_boss_phone,
      m_boss_email: editForm.value.m_boss_email,
      m_tell: editForm.value.m_tell,
      m_addr: editForm.value.m_addr,
      m_jungwon: editForm.value.m_jungwon,
      m_hyunwon: editForm.value.m_hyunwon,
    };
    // 활성/비활성·삭제는 관리자(90+)만
    if (canDeleteMember.value) {
      updateData.m_status = editForm.value.m_status;
    }

    if (isAdmin.value) {
      updateData.wage_assignee_ids = [...wageAssigneeIds.value];
      updateData.account_assignee_ids = [...accountAssigneeIds.value];
    }

    const response = await memberApi.update(editForm.value.m_code || editForm.value.m_idx, updateData);

    if (response.data.success) {
      store.dispatch('showSuccess', '저장되었습니다.');
      detailDialog.value = false;
      fetchMemberList();
    }
  } catch (error: any) {
    console.error('수정 오류:', error);
    const message = error.response?.data?.message || error.message || '저장에 실패했습니다.';
    store.dispatch('showError', message);
  } finally {
    editLoading.value = false;
  }
};

const getBizGubunColor = (bizGubun: string) => {
  return bizGubunColorMap.value[bizGubun] || '#9E9E9E';
};

// 사업구분 문자열 파싱 (콤마 구분)
const parseBizGubun = (bizGubunStr: string | null | undefined): string[] => {
  if (!bizGubunStr) return [];
  return bizGubunStr.split(',').map(s => s.trim()).filter(Boolean);
};

// 수정 모드: 선택된 사업구분 Set
const selectedBizGubunSet = computed(() => {
  return new Set(parseBizGubun(editForm.value?.m_biz_gubun));
});

// 현재 선택된 사업구분의 exclusive_group 조회
const getSelectedExclusiveGroup = (): string | null => {
  const selected = parseBizGubun(editForm.value?.m_biz_gubun);
  if (selected.length === 0) return null;
  
  const firstSelected = selected[0];
  const biz = bizGubunList.value.find(b => b.bg_name === firstSelected);
  return biz?.bg_exclusive_group || null;
};

// 특정 그룹이 비활성화되어야 하는지 확인
const isBizGubunDisabled = (exclusiveGroup: string | null): boolean => {
  const currentGroup = getSelectedExclusiveGroup();
  if (!currentGroup) return false;
  if (!exclusiveGroup) return false;
  return currentGroup !== exclusiveGroup;
};

// 사업구분 토글
const toggleBizGubun = (bizName: string, exclusiveGroup: string | null) => {
  const current = parseBizGubun(editForm.value?.m_biz_gubun);
  const idx = current.indexOf(bizName);
  
  if (idx >= 0) {
    current.splice(idx, 1);
  } else {
    const currentGroup = getSelectedExclusiveGroup();
    if (currentGroup && currentGroup !== exclusiveGroup) {
      return;
    }
    current.push(bizName);
  }
  
  // DB 순서대로 정렬
  const orderedBizList = bizGubunList.value.map(b => b.bg_name);
  current.sort((a, b) => orderedBizList.indexOf(a) - orderedBizList.indexOf(b));
  
  editForm.value.m_biz_gubun = current.join(',');
};

const getCapacityPercent = (item: any) => {
  if (!item.m_jungwon) return 0;
  return Math.min(100, (item.m_hyunwon / item.m_jungwon) * 100);
};

const getCapacityClass = (item: any) => {
  const percent = getCapacityPercent(item);
  if (percent >= 90) return 'high';
  if (percent >= 70) return 'medium';
  return 'low';
};

const getRoleColor = (roleLevel: number) => {
  if (roleLevel >= 90) return 'red';
  if (roleLevel >= 60) return 'orange';
  if (roleLevel >= 50) return 'blue';
  return 'teal';
};

// 삭제 확인 — 관리자(90+)만
const confirmDelete = (member: any) => {
  if (!canDeleteMember.value) {
    store.dispatch('showError', '기관 삭제는 관리자만 가능합니다.');
    return;
  }
  deleteTarget.value = member;
  deleteDialog.value = true;
};

// 멤버 삭제
const deleteMember = async () => {
  if (!deleteTarget.value) return;
  if (!canDeleteMember.value) {
    store.dispatch('showError', '기관 삭제는 관리자만 가능합니다.');
    deleteDialog.value = false;
    return;
  }

  deleteLoading.value = true;
  try {
    await memberApi.delete(deleteTarget.value.m_code);
    store.dispatch('showSuccess', '탈퇴 처리되었습니다. 같은 정보로 다시 가입할 수 있습니다.');
    deleteDialog.value = false;
    deleteTarget.value = null;
    fetchMemberList();
  } catch (error: any) {
    console.error('멤버 삭제 오류:', error);
    store.dispatch('showError', error.response?.data?.message || '탈퇴 처리에 실패했습니다.');
  } finally {
    deleteLoading.value = false;
  }
};

// 대리 로그인 실행 (바로 접속)
const route = useRoute();

onMounted(() => {
  const querySearch = route.query.search;
  if (typeof querySearch === 'string' && querySearch.trim()) {
    searchText.value = querySearch.trim();
  }
  fetchMemberList();
  fetchBizGubunList();
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "console-page-copy" }, [
        _createElementVNode("p", { class: "console-kicker" }, "조직"),
        _createElementVNode("h2", { class: "console-title" }, "고객관리")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(totalCount.value.toLocaleString()) + "건", 1)
      ])
    ]),
    (canSeeServiceTabs.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            role: "tab",
            class: _normalizeClass(["member-service-tab member-service-tab--service", { active: serviceTab.value === 'service' }]),
            "aria-selected": serviceTab.value === 'service',
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setServiceTab('service')))
          }, [
            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "tab-text" }, [
              _createElementVNode("span", { class: "tab-label" }, "임금·회계 이용"),
              _createElementVNode("span", { class: "tab-desc" }, "담당자가 배정된 기관")
            ], -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(tabCounts.value.service), 1)
          ], 10, _hoisted_6),
          _createElementVNode("button", {
            type: "button",
            role: "tab",
            class: _normalizeClass(["member-service-tab member-service-tab--none", { active: serviceTab.value === 'none' }]),
            "aria-selected": serviceTab.value === 'none',
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setServiceTab('none')))
          }, [
            _cache[23] || (_cache[23] = _createElementVNode("span", { class: "tab-text" }, [
              _createElementVNode("span", { class: "tab-label" }, "서비스 미이용"),
              _createElementVNode("span", { class: "tab-desc" }, "담당자가 없는 기관")
            ], -1)),
            _createElementVNode("span", _hoisted_9, _toDisplayString(tabCounts.value.none), 1)
          ], 10, _hoisted_8)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_v_row, {
              align: "center",
              dense: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: searchText.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchText).value = $event)),
                      placeholder: "시설명, ID, 시설코드로 검색...",
                      "prepend-inner-icon": "mdi-magnify",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      clearable: "",
                      onKeyup: _withKeys(fetchMemberList, ["enter"]),
                      "onClick:clear": onClearSearch
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  md: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: selectedBizGubun.value,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => ((selectedBizGubun).value = $event)),
                        fetchMemberList
                      ],
                      items: bizGubunOptions.value,
                      "item-title": "bg_name",
                      "item-value": "bg_value",
                      label: "사업구분",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": ""
                    }, {
                      item: _withCtx(({ props, item }) => [
                        _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), _createSlots({ _: 2 }, [
                          (item.raw.bg_color)
                            ? {
                                name: "prepend",
                                fn: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: "color-dot",
                                    style: _normalizeStyle({ background: item.raw.bg_color })
                                  }, null, 4)
                                ]),
                                key: "0"
                              }
                            : undefined
                        ]), 1040)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  md: "2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: selectedStatus.value,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => ((selectedStatus).value = $event)),
                        fetchMemberList
                      ],
                      items: statusOptions,
                      "item-title": "text",
                      "item-value": "value",
                      label: "상태",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "2",
                  class: "d-flex gap-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      class: "btn-search",
                      onClick: fetchMemberList,
                      block: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: "small",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                            _createTextVNode("mdi-magnify", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[25] || (_cache[25] = _createTextVNode(" 검색 ", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_v_data_table, {
            headers: headers,
            items: memberList.value,
            loading: loading.value,
            "items-per-page": itemsPerPage.value,
            page: currentPage.value,
            hover: "",
            class: "member-table"
          }, {
            "item.index": _withCtx(({ index }) => [
              _createElementVNode("span", _hoisted_14, _toDisplayString((currentPage.value - 1) * itemsPerPage.value + index + 1), 1)
            ]),
            "item.m_name": _withCtx(({ item }) => [
              _createElementVNode("div", {
                class: "member-name clickable",
                onClick: ($event: any) => (openMemberPopup(item))
              }, [
                _createElementVNode("span", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(item.m_name), 1),
                  (item.m_signup_source === 'WEB')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "쇼핑몰"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", _hoisted_19, _toDisplayString(item.m_longterm_code), 1)
              ], 8, _hoisted_15)
            ]),
            "item.m_biz_gubun": _withCtx(({ item }) => [
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseBizGubun(item.m_biz_gubun), (biz) => {
                  return (_openBlock(), _createBlock(_component_v_chip, {
                    key: biz,
                    color: getBizGubunColor(biz),
                    size: "x-small",
                    label: "",
                    variant: "flat",
                    class: "biz-chip"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(biz), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"]))
                }), 128)),
                (!item.m_biz_gubun)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, "-"))
                  : _createCommentVNode("", true)
              ])
            ]),
            "item.wage_manager": _withCtx(({ item }) => [
              _createElementVNode("div", {
                class: "assignee-cell",
                title: formatAssigneeTitle(item.wage_assignees)
              }, [
                ((item.wage_assignees || []).length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleAssigneeNames(item.wage_assignees), (name) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: `w-${item.m_code}-${name}`,
                          class: "assignee-name-chip assignee-name-chip--wage"
                        }, _toDisplayString(name), 1))
                      }), 128)),
                      (hiddenAssigneeCount(item.wage_assignees) > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, "+" + _toDisplayString(hiddenAssigneeCount(item.wage_assignees)), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock("span", _hoisted_24, "-"))
              ], 8, _hoisted_22)
            ]),
            "item.account_manager": _withCtx(({ item }) => [
              _createElementVNode("div", {
                class: "assignee-cell",
                title: formatAssigneeTitle(item.account_assignees)
              }, [
                ((item.account_assignees || []).length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleAssigneeNames(item.account_assignees), (name) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: `a-${item.m_code}-${name}`,
                          class: "assignee-name-chip assignee-name-chip--account"
                        }, _toDisplayString(name), 1))
                      }), 128)),
                      (hiddenAssigneeCount(item.account_assignees) > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, "+" + _toDisplayString(hiddenAssigneeCount(item.account_assignees)), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock("span", _hoisted_27, "-"))
              ], 8, _hoisted_25)
            ]),
            "item.m_boss_name": _withCtx(({ item }) => [
              _createElementVNode("span", null, _toDisplayString(item.m_boss_name || '-'), 1)
            ]),
            "item.m_wdate": _withCtx(({ item }) => [
              _createElementVNode("span", _hoisted_28, _toDisplayString(formatJoinedDate(item.m_wdate)), 1)
            ]),
            "item.last_activity": _withCtx(({ item }) => [
              _createElementVNode("div", {
                class: "last-activity",
                title: formatActivityFull(item.last_activity_at)
              }, [
                _createElementVNode("span", _hoisted_30, _toDisplayString(item.last_activity_label || '-'), 1),
                (item.last_activity_at)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(formatActivityTime(item.last_activity_at)), 1))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_29)
            ]),
            "item.m_status": _withCtx(({ item }) => [
              _createElementVNode("span", {
                class: _normalizeClass(["status-dot", item.m_status === 1 ? 'active' : 'inactive'])
              }, null, 2)
            ]),
            "item.actions": _withCtx(({ item }) => [
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_v_btn, {
                  size: "small",
                  variant: "flat",
                  class: "btn-edit",
                  onClick: _withModifiers(($event: any) => (openEditDialog(item)), ["stop"])
                }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                    _createTextVNode(" 수정 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                (canDeleteMember.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      size: "small",
                      variant: "text",
                      class: "btn-delete",
                      onClick: _withModifiers(($event: any) => (confirmDelete(item)), ["stop"])
                    }, {
                      default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                        _createTextVNode(" 삭제 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            "no-data": _withCtx(() => [
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_v_icon, {
                  size: "64",
                  color: "grey-lighten-1"
                }, {
                  default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                    _createTextVNode("mdi-domain-off", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("p", null, _toDisplayString(emptyListMessage.value), 1)
              ])
            ]),
            bottom: _withCtx(() => [
              _createVNode(TablePagination, {
                "current-page": currentPage.value,
                "onUpdate:currentPage": [
                  _cache[5] || (_cache[5] = ($event: any) => ((currentPage).value = $event)),
                  onPageChange
                ],
                "items-per-page": itemsPerPage.value,
                "onUpdate:itemsPerPage": [
                  _cache[6] || (_cache[6] = ($event: any) => ((itemsPerPage).value = $event)),
                  onItemsPerPageChange
                ],
                "total-count": totalCount.value,
                "total-pages": totalPages.value
              }, null, 8, ["current-page", "items-per-page", "total-count", "total-pages"])
            ]),
            _: 1
          }, 8, ["items", "loading", "items-per-page", "page"])
        ])
      ])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: detailDialog.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((detailDialog).value = $event)),
      "max-width": "720px",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "detail-dialog member-edit-dialog" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "dialog-header" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { class: "mr-2" }, {
                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                    _createTextVNode("mdi-pencil-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[31] || (_cache[31] = _createElementVNode("span", null, "시설 정보 수정", -1)),
                _createVNode(_component_v_chip, {
                  color: editForm.value.m_status === 1 ? 'success' : 'grey',
                  size: "x-small",
                  class: "ml-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(editForm.value.m_status === 1 ? '활성' : '비활성'), 1)
                  ]),
                  _: 1
                }, 8, ["color"]),
                _createElementVNode("button", {
                  type: "button",
                  class: "member-edit-dialog__close",
                  disabled: editLoading.value,
                  "aria-label": "닫기",
                  onClick: closeEditDialog
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ], 8, _hoisted_34)
              ]),
              _: 1
            }),
            (editForm.value)
              ? (_openBlock(), _createBlock(_component_v_card_text, {
                  key: 0,
                  class: "member-edit-body"
                }, {
                  default: _withCtx(() => [
                    _createVNode(LoadingOverlay, {
                      show: detailLoading.value || editLoading.value,
                      text: editLoading.value ? '저장 중...' : '불러오는 중...'
                    }, null, 8, ["show", "text"]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _cache[40] || (_cache[40] = _createElementVNode("h4", { class: "section-title" }, "기본 정보", -1)),
                        _createElementVNode("div", _hoisted_37, [
                          _cache[32] || (_cache[32] = _createElementVNode("span", { class: "label" }, "시설명 *", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editForm.value.m_name) = $event)),
                            type: "text",
                            class: "native-input",
                            placeholder: "시설명을 입력하세요"
                          }, null, 512), [
                            [_vModelText, editForm.value.m_name]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _cache[33] || (_cache[33] = _createElementVNode("span", { class: "label" }, "시설코드", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editForm.value.m_longterm_code) = $event)),
                            type: "text",
                            class: "native-input disabled",
                            disabled: ""
                          }, null, 512), [
                            [_vModelText, editForm.value.m_longterm_code]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _cache[34] || (_cache[34] = _createElementVNode("span", { class: "label" }, "사업구분 *", -1)),
                          _createElementVNode("div", _hoisted_40, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bizGubunList.value, (biz) => {
                              return (_openBlock(), _createElementBlock("label", {
                                key: biz.bg_name,
                                class: _normalizeClass(["assignee-check", { disabled: isBizGubunDisabled(biz.bg_exclusive_group) }])
                              }, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  checked: selectedBizGubunSet.value.has(biz.bg_name),
                                  disabled: isBizGubunDisabled(biz.bg_exclusive_group),
                                  onChange: ($event: any) => (toggleBizGubun(biz.bg_name, biz.bg_exclusive_group))
                                }, null, 40, _hoisted_41),
                                _createElementVNode("span", null, _toDisplayString(biz.bg_name), 1)
                              ], 2))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _cache[35] || (_cache[35] = _createElementVNode("span", { class: "label" }, "사업자번호", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editForm.value.m_biz_num) = $event)),
                            type: "text",
                            class: "native-input",
                            placeholder: "000-00-00000"
                          }, null, 512), [
                            [_vModelText, editForm.value.m_biz_num]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _cache[38] || (_cache[38] = _createElementVNode("span", { class: "label" }, "현원/정원", -1)),
                          _createElementVNode("div", _hoisted_44, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editForm.value.m_hyunwon) = $event)),
                              type: "number",
                              class: "native-input small",
                              placeholder: "현원",
                              min: "0"
                            }, null, 512), [
                              [
                                _vModelText,
                                editForm.value.m_hyunwon,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _cache[36] || (_cache[36] = _createElementVNode("span", { class: "separator" }, "/", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editForm.value.m_jungwon) = $event)),
                              type: "number",
                              class: "native-input small",
                              placeholder: "정원",
                              min: "0"
                            }, null, 512), [
                              [
                                _vModelText,
                                editForm.value.m_jungwon,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _cache[37] || (_cache[37] = _createElementVNode("span", { class: "unit" }, "명", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _cache[39] || (_cache[39] = _createElementVNode("span", { class: "label" }, "상태", -1)),
                          (canDeleteMember.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass(['status-btn', { active: editForm.value.m_status === 1 }]),
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (editForm.value.m_status = 1))
                                }, "활성", 2),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass(['status-btn inactive', { active: editForm.value.m_status === 0 }]),
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (editForm.value.m_status = 0))
                                }, "비활성", 2)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(editForm.value.m_status === 1 ? '활성' : '비활성'), 1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _cache[44] || (_cache[44] = _createElementVNode("h4", { class: "section-title" }, "대표자 정보", -1)),
                        _createElementVNode("div", _hoisted_49, [
                          _cache[41] || (_cache[41] = _createElementVNode("span", { class: "label" }, "대표자", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((editForm.value.m_boss_name) = $event)),
                            type: "text",
                            class: "native-input",
                            placeholder: "대표자명"
                          }, null, 512), [
                            [_vModelText, editForm.value.m_boss_name]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _cache[42] || (_cache[42] = _createElementVNode("span", { class: "label" }, "연락처", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((editForm.value.m_boss_phone) = $event)),
                            type: "tel",
                            class: "native-input",
                            placeholder: "010-0000-0000"
                          }, null, 512), [
                            [_vModelText, editForm.value.m_boss_phone]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _cache[43] || (_cache[43] = _createElementVNode("span", { class: "label" }, "이메일", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((editForm.value.m_boss_email) = $event)),
                            type: "email",
                            class: "native-input",
                            placeholder: "email@example.com"
                          }, null, 512), [
                            [_vModelText, editForm.value.m_boss_email]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _cache[52] || (_cache[52] = _createElementVNode("h4", { class: "section-title" }, "담당 권한", -1)),
                        (isAdmin.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_53, [
                                _cache[45] || (_cache[45] = _createElementVNode("span", { class: "label" }, "임금담당", -1)),
                                _createElementVNode("div", _hoisted_54, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(managerList.value, (manager) => {
                                    return (_openBlock(), _createElementBlock("label", {
                                      key: `wage-${manager.u_idx}`,
                                      class: "assignee-check"
                                    }, [
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        value: manager.u_idx,
                                        checked: wageAssigneeIds.value.includes(manager.u_idx),
                                        onChange: ($event: any) => (onAssigneeCheck('wage', manager.u_idx, $event))
                                      }, null, 40, _hoisted_55),
                                      _createElementVNode("span", null, _toDisplayString(manager.u_name), 1)
                                    ]))
                                  }), 128)),
                                  (managerLoading.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_56, "불러오는 중..."))
                                    : (!managerList.value.length)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_57, "담당자 후보 없음"))
                                      : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_58, [
                                _cache[46] || (_cache[46] = _createElementVNode("span", { class: "label" }, "회계담당", -1)),
                                _createElementVNode("div", _hoisted_59, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(managerList.value, (manager) => {
                                    return (_openBlock(), _createElementBlock("label", {
                                      key: `account-${manager.u_idx}`,
                                      class: "assignee-check"
                                    }, [
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        value: manager.u_idx,
                                        checked: accountAssigneeIds.value.includes(manager.u_idx),
                                        onChange: ($event: any) => (onAssigneeCheck('account', manager.u_idx, $event))
                                      }, null, 40, _hoisted_60),
                                      _createElementVNode("span", null, _toDisplayString(manager.u_name), 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_61, [
                                _cache[47] || (_cache[47] = _createElementVNode("span", { class: "label" }, "임금담당", -1)),
                                _createElementVNode("span", _hoisted_62, _toDisplayString(editForm.value.wage_assignee_names || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_63, [
                                _cache[48] || (_cache[48] = _createElementVNode("span", { class: "label" }, "회계담당", -1)),
                                _createElementVNode("span", _hoisted_64, _toDisplayString(editForm.value.account_assignee_names || '-'), 1)
                              ]),
                              _cache[49] || (_cache[49] = _createElementVNode("p", { class: "assignee-hint" }, "담당자 배정은 관리자만 변경할 수 있습니다.", -1))
                            ], 64)),
                        _createElementVNode("div", _hoisted_65, [
                          _cache[50] || (_cache[50] = _createElementVNode("span", { class: "label" }, "주소", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((editForm.value.m_addr) = $event)),
                            type: "text",
                            class: "native-input",
                            placeholder: "주소를 입력하세요"
                          }, null, 512), [
                            [_vModelText, editForm.value.m_addr]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_66, [
                          _cache[51] || (_cache[51] = _createElementVNode("span", { class: "label" }, "전화번호", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((editForm.value.m_tell) = $event)),
                            type: "tel",
                            class: "native-input",
                            placeholder: "02-0000-0000"
                          }, null, 512), [
                            [_vModelText, editForm.value.m_tell]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_card_actions, { class: "dialog-actions" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "btn-cancel",
                  disabled: editLoading.value,
                  onClick: closeEditDialog
                }, {
                  default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                    _createTextVNode(" 취소 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "btn-save",
                  loading: editLoading.value,
                  disabled: detailLoading.value,
                  onClick: saveEdit
                }, {
                  default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                    _createTextVNode(" 저장 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(DeleteConfirmDialog, {
      modelValue: deleteDialog.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((deleteDialog).value = $event)),
      title: "기관 계정 삭제",
      "target-name": deleteTarget.value?.m_name || '',
      message: "계정을 삭제합니다. 같은 아이디·기관기호로 다시 가입할 수는 있습니다.",
      warning: "되돌릴 수 없습니다. 삭제된 고객은 복원할 수 없으니 신중히 진행해 주세요.",
      loading: deleteLoading.value,
      onConfirm: deleteMember
    }, null, 8, ["modelValue", "target-name", "loading"])
  ]))
}
}

})